import { useEffect, useRef } from "react";

export default function DetailTabs({ tabs = [], activeTab, onChange }) {
  const containerRef = useRef(null);

  // Sekmeler yatay kayıyorsa aktif sekme görünür alana getirilir.
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const activeEl = container.querySelector(`[data-tab-id="${activeTab}"]`);
    if (!activeEl) return;
    if (container.scrollWidth > container.clientWidth) {
      activeEl.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }
  }, [activeTab, tabs.length]);

  return (
    <div
      ref={containerRef}
      className="flex bg-white overflow-x-auto shrink-0 scrollbar-hide px-2 py-1.5 sm:p-2 gap-2 sm:gap-1.5 border-b border-gray-200"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            data-tab-id={tab.id}
            onClick={() => onChange(tab.id)}
            className={`shrink-0 sm:flex-1 py-2.5 sm:py-2 px-4 sm:px-3 flex items-center justify-center gap-2 sm:gap-1.5 transition-all duration-200 rounded-xl whitespace-nowrap ${
              isActive
                ? `${tab.bg} text-white shadow-sm`
                : "text-gray-500 hover:bg-gray-100"
            }`}
          >
            <Icon
              className={`w-4 h-4 shrink-0 ${
                isActive ? "text-white" : "text-gray-400"
              }`}
            />
            <span
              className={`text-[13px] sm:text-sm font-medium ${
                isActive ? "text-white" : ""
              }`}
            >
              {tab.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
